import * as React from 'react';
import WebGLDirector from './WebGLDirector';
import WebGLText from './WebGLText';
import WebGLTextOrientation from './WebGLTextOrientation';
import WebGLCartesianCoordinates from './shapes/composites/WebGLCartesianCoordinates';
import WebGLArrow from './shapes/composites/WebGLArrow';
import Color from './Color';

export default class VectorsInACartesianPlaneComponent extends React.Component<{size: number}, void> {

	private canvas: HTMLCanvasElement;
	private textOverlay: HTMLDivElement;

	componentDidMount () {
		const director = new WebGLDirector(this.canvas, this.props.size, this.props.size, this.textOverlay);

		director.addShape(WebGLCartesianCoordinates.create(-1, -1, 1, 1, 20, 20));

		this.drawVector(director, 5, 4, Color.white());
		this.drawVector(director, 4, 1, Color.cyan());
		this.drawVector(director, 4, -1, Color.pink());
		this.drawVector(director, 5, -4, Color.pinkPale());
		this.drawVector(director, 0, -7, Color.violet());
		this.drawVector(director, -1, -8, Color.blueMatte());
		this.drawVector(director, -5, -5, Color.bluePale());
		this.drawVector(director, -5, -2, Color.red());
		this.drawVector(director, -3, 1, Color.green());
		this.drawVector(director, -3, 9, Color.yellow());

		director.drawScene();
	}

	drawVector (director: WebGLDirector, x2: number, y2: number, color: Color) {
		const orientation = x2 >= 0 ? (y2 > 0 ? WebGLTextOrientation.TOP_RIGHT : WebGLTextOrientation.BOTTOM_RIGHT) : (y2 > 0 ? WebGLTextOrientation.TOP_LEFT : WebGLTextOrientation.BOTTOM_LEFT);

		director.addShape(WebGLArrow.fromNumbers(0, 0, x2 / 10, y2 / 10).setColor(color));
		director.addText(new WebGLText(`(${x2}, ${y2})`, x2 / 10, y2 / 10, orientation, 4));
	}

	render () {
		const pixelSize = this.props.size + 'px';
		const renderSize = this.props.size * 2;

		return (
			<div style={{position: 'relative', width: pixelSize, margin: 'auto'}}>
				<canvas ref={element => this.canvas = element} width={renderSize} height={renderSize} style={{width: pixelSize, height: pixelSize}} />
				<div ref={element => this.textOverlay = element} style={{position: 'absolute', top: 0, width: pixelSize, height: pixelSize}} />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/webGL/VectorsInACartesianPlaneComponent.tsx